export class FilterChange {
  static readonly type = '[SupervisorDashboard] FilterChange';
  constructor(public filters: any) {}
}
